import { Box } from "@mui/system";
import CommCard from "src/common/CommCard";
import CreateInvoice from "./CreateInvoice";

const CreateExhibitorInvoice = () => {
	return (
		<CommCard
			helmetTitle='BTTF - Create a exhibitor invoice'
			headerTitle='Create Invoice'
			showCardHeader
		>
			<Box sx={{ marginTop: "15px", mx: 3 }}>
				<CreateInvoice />
			</Box>
		</CommCard>
	);
};

export default CreateExhibitorInvoice;
